<template>
  <div class="logo" direction="vertical">
    <div class="site-name" :style="{ color: position === 'login' ? '#303133' : '#fff' }">
      <div class="site-name-img jia" v-if="sysInfo.brandName === '嘉岚翎'">
        <img v-if="position === 'login'" src="../assets/logo_jia_blue.png" />
        <img v-else src="../assets/logo_jia_white.png" />
      </div>
      <div class="site-name-img" v-else-if="sysInfo.brandName === '比利'">
        <img v-if="position === 'login'" src="../assets/bili-logo-red.png" />
        <img v-else src="../assets/bili-logo-red.png" />
      </div>
      <div class="site-name-img" v-else>
        <img v-if="position === 'login'" src="../assets/logo-login.png" />
        <img v-else src="../assets/logo-wihte.png" />
      </div>
      <div class="site-name-title" v-if="sysInfo.brandName !== '比利'">
        {{ sysInfo.brandName }}广告投放平台
      </div>
      <div class="site-name-title" v-else>
        你的旅游新媒体平台 &nbsp; Your Travel Media Network
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    position: {
      type: String
    }
  },
  computed: {
    ...mapGetters(['sysInfo'])
  },
  methods: {
    setFavicon(url) {
      let link = document.querySelector('#favicon')

      if (!link) {
        link = document.createElement('link')
        link.id = 'dynamic-favicon'
        link.rel = 'icon'
        document.head.appendChild(link)
      }

      link.href = url
    }
  },
  created() {
    this.$service.getSystemTag().then((res) => {
      let result = {}
      if (res && res.dictLabel) {
        result = {
          brandName: res.dictLabel,
          brandNo: res.dictValue
        }
      } else {
        result = {
          brandName: '酷开',
          brandNo: 'coocaa'
        }
      }
      // 特殊处理比利品牌
      if (location.href.includes('mycool.tv')) {
        result = {
          brandName: '比利',
          brandNo: 'mycool'
        }
        this.$store.commit('setSysInfo', result)
        document.getElementById('hTitle').innerHTML = '你的旅游新媒体平台'
        this.setFavicon('/favicon_bili.ico')
        return
      }
      this.$store.commit('setSysInfo', result)
      document.getElementById('hTitle').innerHTML = result.brandName + '广告投放平台'
    })
  }
}
</script>

<style lang="stylus" scoped>
.logo
  height 3.125rem
  font-size 1rem
  .site-name
    display flex
    align-items center
    color #303133
    font-weight 400
    height inherit
    .site-name-img
      height 1.4rem
      padding-right 1rem
      img
        max-height 100%
      &.jia
        height 46px
    .site-name-title
      padding-left 1rem
      font-size 16px
      border-left 1px solid #ddd
</style>
